// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../ui/styles/tavern-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tavern-themed Welcome Page */


.welcome-page {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
  padding: 0;
  background: none;
}

.welcome-container {
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  min-height: 0;
  overflow: hidden;
}

/* Logo Container (sticky) */
.logo-container {
  /* align-self: flex-start; */
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--color-wood-900);
  padding-top: var(--space-5);
  padding-bottom: var(--space-3);
  text-align: center;
  animation: fade-in 600ms ease-out;
}

.logo {
  width: 240px;
  height: 240px;
  background: var(--color-parchment-100);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 3px solid var(--color-wood-700);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--space-3);
  box-shadow: 0 4px 12px rgba(26, 20, 16, 0.3), inset 0 2px 8px rgba(0,0,0,0.08);
  position: relative;
  overflow: hidden;
}

.logo::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 70%
  );
  animation: shine 3s infinite;
}

@keyframes shine {
  0% { 
    transform: translateX(-100%) translateY(-100%) rotate(45deg); 
  }
  100% { 
    transform: translateX(100%) translateY(100%) rotate(45deg); 
  }
}

.welcome-title {
  font-family: var(--font-heading);
  font-size: 32px;
  font-weight: 700;
  color: var(--color-parchment-100);
  margin-bottom: var(--space-2);
}

.welcome-subtitle {
  font-size: 16px;
  color: var(--color-parchment-300);
}

/* Rules Scroll */
.rules-scroll {
  background: var(--color-parchment-100);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  padding: var(--space-4);
  margin-bottom: 0;
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  text-align: left;
  box-shadow: 0 4px 12px rgba(26, 20, 16, 0.18);
  animation: scale-in 500ms ease-out 200ms backwards;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

@keyframes scale-in {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.rules-title {
  font-family: var(--font-heading);
  font-size: 20px;
  color: var(--color-fire-600);
  margin-bottom: var(--space-4);
  text-align: center;
}

/* Rule Items */
.rule-item {
  padding: var(--space-3);
  margin-bottom: var(--space-3);
  border-left: 3px solid var(--color-fire-600);
  padding-left: var(--space-4);
  background: rgba(184, 71, 14, 0.05);
  border-radius: var(--radius-md);
  font-size: var(--font-size-body);
  line-height: var(--line-height-body-lg);
  color: var(--color-text-primary);
}

.rule-item:last-child {
  margin-bottom: 0;
}

.rule-number {
  font-family: var(--font-heading);
  font-weight: 700;
  color: var(--color-fire-600);
  margin-right: var(--space-2);
}

/* Accept Button */

.welcome-action {
  width: 100%;
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: var(--color-wood-900);
  padding-bottom: var(--space-2);
  padding-top: var(--space-2);
  box-shadow: 0 -2px 8px rgba(26,20,16,0.08);
  flex: 0 0 auto;
}

.accept-button {
  min-height: 40px;
  font-size: 16px;
  padding: 8px 0;
  border-radius: 8px;
  max-width: 320px;
  margin: 0 auto;
  animation: fade-in-up 500ms ease-out 400ms backwards;
}

/* Мобильная адаптация: 375px */
@media (max-width: 425px) {
  .logo {
    width: 160px;
    height: 160px;
    border-width: 2px;
    margin-bottom: var(--space-2);
  }
  .rules-scroll {
    max-height: none;
    padding: var(--space-2);
    font-size: 13px;
    margin-bottom: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .accept-button {
    min-height: 36px;
    font-size: 15px;
    padding: 4px 0;
    max-width: 220px;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Error Alert */
.welcome-error-alert {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(180, 60, 60, 0.35);
  background: rgba(180, 60, 60, 0.12);
  color: #ffd2d2;
  font-size: 13px;
  line-height: 1.3;
}


@media (min-width: 768px) {
  .welcome-container {
    box-shadow: 0 0 0 2px var(--color-wood-700);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Welcome/WelcomePage.css"],"names":[],"mappings":"AAGA,+BAA+B;;;AAG/B;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,8EAA8E;EAC9E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,4BAA4B;AAC9B;;AAEA;EACE;IACE,4DAA4D;EAC9D;EACA;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC;;;;;kIAKgI;EAChI,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,kDAAkD;EAClD,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4CAA4C;EAC5C,4BAA4B;EAC5B,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,kBAAkB;;AAElB;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oDAAoD;AACtD;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE;IACE,2CAA2C;EAC7C;AACF","sourcesContent":["@import '../_base.css';\n@import '../../ui/styles/tavern-components.css';\n\n/* Tavern-themed Welcome Page */\n\n\n.welcome-page {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  padding: 0;\n  background: none;\n}\n\n.welcome-container {\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  max-width: 480px;\n  width: 100%;\n  margin: 0 auto;\n  text-align: center;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Logo Container (sticky) */\n.logo-container {\n  /* align-self: flex-start; */\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--color-wood-900);\n  padding-top: var(--space-5);\n  padding-bottom: var(--space-3);\n  text-align: center;\n  animation: fade-in 600ms ease-out;\n}\n\n.logo {\n  width: 240px;\n  height: 240px;\n  background: var(--color-parchment-100);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border: 3px solid var(--color-wood-700);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto var(--space-3);\n  box-shadow: 0 4px 12px rgba(26, 20, 16, 0.3), inset 0 2px 8px rgba(0,0,0,0.08);\n  position: relative;\n  overflow: hidden;\n}\n\n.logo::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent 30%,\n    rgba(255, 255, 255, 0.1) 50%,\n    transparent 70%\n  );\n  animation: shine 3s infinite;\n}\n\n@keyframes shine {\n  0% { \n    transform: translateX(-100%) translateY(-100%) rotate(45deg); \n  }\n  100% { \n    transform: translateX(100%) translateY(100%) rotate(45deg); \n  }\n}\n\n.welcome-title {\n  font-family: var(--font-heading);\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  margin-bottom: var(--space-2);\n}\n\n.welcome-subtitle {\n  font-size: 16px;\n  color: var(--color-parchment-300);\n}\n\n/* Rules Scroll */\n.rules-scroll {\n  background: var(--color-parchment-100);\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  padding: var(--space-4);\n  margin-bottom: 0;\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow-y: auto;\n  text-align: left;\n  box-shadow: 0 4px 12px rgba(26, 20, 16, 0.18);\n  animation: scale-in 500ms ease-out 200ms backwards;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n@keyframes scale-in {\n  0% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.rules-title {\n  font-family: var(--font-heading);\n  font-size: 20px;\n  color: var(--color-fire-600);\n  margin-bottom: var(--space-4);\n  text-align: center;\n}\n\n/* Rule Items */\n.rule-item {\n  padding: var(--space-3);\n  margin-bottom: var(--space-3);\n  border-left: 3px solid var(--color-fire-600);\n  padding-left: var(--space-4);\n  background: rgba(184, 71, 14, 0.05);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-body);\n  line-height: var(--line-height-body-lg);\n  color: var(--color-text-primary);\n}\n\n.rule-item:last-child {\n  margin-bottom: 0;\n}\n\n.rule-number {\n  font-family: var(--font-heading);\n  font-weight: 700;\n  color: var(--color-fire-600);\n  margin-right: var(--space-2);\n}\n\n/* Accept Button */\n\n.welcome-action {\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background: var(--color-wood-900);\n  padding-bottom: var(--space-2);\n  padding-top: var(--space-2);\n  box-shadow: 0 -2px 8px rgba(26,20,16,0.08);\n  flex: 0 0 auto;\n}\n\n.accept-button {\n  min-height: 40px;\n  font-size: 16px;\n  padding: 8px 0;\n  border-radius: 8px;\n  max-width: 320px;\n  margin: 0 auto;\n  animation: fade-in-up 500ms ease-out 400ms backwards;\n}\n\n/* Мобильная адаптация: 375px */\n@media (max-width: 425px) {\n  .logo {\n    width: 160px;\n    height: 160px;\n    border-width: 2px;\n    margin-bottom: var(--space-2);\n  }\n  .rules-scroll {\n    max-height: none;\n    padding: var(--space-2);\n    font-size: 13px;\n    margin-bottom: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .accept-button {\n    min-height: 36px;\n    font-size: 15px;\n    padding: 4px 0;\n    max-width: 220px;\n  }\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-up {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Error Alert */\n.welcome-error-alert {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(180, 60, 60, 0.35);\n  background: rgba(180, 60, 60, 0.12);\n  color: #ffd2d2;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n\n@media (min-width: 768px) {\n  .welcome-container {\n    box-shadow: 0 0 0 2px var(--color-wood-700);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
